import { Box } from '@mui/material';
import {
  MemoStatefulAutocompleteWithText,
  MemoStatefulMultiselect,
} from 'components/dataCreationForms/withInputForm/statefulInputsWrapper';
import React from 'react';
import { ContractFormPresentationalProps } from './types';
import { contractGridSx } from '../layout';

export function ContractFormPresentational({
  labelFieldProps,
  partiesFieldProps,
}: ContractFormPresentationalProps): React.ReactElement {
  return (
    <Box sx={contractGridSx}>
      <Box>
        <MemoStatefulAutocompleteWithText {...labelFieldProps} />
      </Box>
      <Box>
        <MemoStatefulMultiselect {...partiesFieldProps} />
      </Box>
    </Box>
  );
}
